import React from "react";
import { CircularProgress } from "@mui/material";
import { PlusIcon } from "@phosphor-icons/react";

const CustomCardList = ({
                            data = [],
                            titleAccessor = "name",
                            imageAccessor = "imageUrl",
                            onAddClick,
                            onCardClick,
                            addButtonText = "Ajouter un élément",
                            cardClassName = "",
                            limit = 12,
                            isLoading = false,
                        }) => {

    const handleCardClick = (item) => {
        if (onCardClick) {
            onCardClick(item);
        }
    };

    const handleAddClick = () => {
        if (onAddClick) {
            onAddClick();
        }
    };

    const getNestedValue = (obj, accessor) => {
        return accessor.split('.').reduce((current, key) => current?.[key], obj);
    };

    if (isLoading) {
        return (
            <div className="loader-container absolute">
                <CircularProgress size={30} />
            </div>
        );
    }

    return (
        <div className="card-list-container">
            <div className="cards-grid">
                {/* Cards des éléments */}
                {Array.isArray(data) && data.slice(0, limit).map((item, index) => {
                    const title = getNestedValue(item, titleAccessor) || "Sans titre";
                    const imageUrl = getNestedValue(item, imageAccessor);

                    return (
                        <div
                            key={item.id || index}
                            className={`card-item data-card ${cardClassName}`}
                            onClick={() => handleCardClick(item)}
                        >
                            <div className="card-image-container">
                                {imageUrl ? (
                                    <img
                                        src={imageUrl}
                                        alt={title}
                                        className="card-image"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                ) : null}
                                <div
                                    className="card-placeholder"
                                    style={{ display: imageUrl ? 'none' : 'flex' }}
                                >
                                    <span className="placeholder-text">Image</span>
                                </div>
                            </div>
                            <div className="card-content">
                                <h3 className="card-title">{title}</h3>
                            </div>
                        </div>
                    );
                })}

                {/* Bouton d'ajout */}
                <div
                    className={`card-item add-card ${cardClassName}`}
                    onClick={handleAddClick}
                >
                    <div className="add-card-content">
                        <PlusIcon size={32} className="add-card-icon" />
                        <span className="add-card-text">{addButtonText}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomCardList;